"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomArgs = void 0;
class RoomArgs {
    constructor(onEntered = [], onExited = [], onTick = [], type = "Beach") {
        this.onEntered = onEntered;
        this.onExited = onExited;
        this.onTick = onTick;
        this.type = type;
    }
}
exports.RoomArgs = RoomArgs;
